import useS3Upload from '#hooks/use-upload.js';
import Button from '#lib/components/button.jsx';
import Dialog from '#lib/components/dialog.jsx';
import FileDnD from '#lib/components/file-dnd.jsx';
import { set } from '#lib/utils/object.js';
import { useState } from 'react';

export function UploadPanel(props) {
    const { isOpen, onClose, upload, setIsUpdatingText } = props;

    const [src, setSrc] = useState(null);
    const [urlToSend, setUrlToSend] = useState(null);
    const [uploading, setUploading] = useState(false);

    const uploadSource = useS3Upload({
        onSuccess: (res) => {
            setUploading(false);
            setUrlToSend(res.tempKey);
        }
    });

    const onUpdateFiles = (_, files) => {
        setUploading(true);
        const hasFile = Boolean(files?.[0]);
        if (hasFile) {
            setSrc(new File([], files[0].name));
        }
    };

    const handleConfirmUpload = () => {
        const confirm = window.confirm(_t.intl.uploadConfirm());
        if (!confirm) return;
        upload.mutate({ url: urlToSend });
        setIsUpdatingText(true);
        onClose();
    };

    return (
        <Dialog isOpen={isOpen}>
            <Dialog.Panel
                static
                className="flex flex-col gap-4 items-end min-w-[350px] w-full max-w-[60px] max-h-[70vh] overflow-auto"
            >
                <div className="w-full pr-4">
                    <Dialog.CloseButton onClick={onClose} />
                    <p className="text-2xl">{_t.intl.upload()}</p>
                </div>
                <FileDnD
                    name="csv"
                    existingFiles={[src]}
                    accept=".csv,text/csv"
                    label={_t.intl.csvFile()}
                    onUpdateFiles={onUpdateFiles}
                    {...uploadSource.props}
                />
                <Button look="primary" busy={uploading} onClick={handleConfirmUpload}>
                    {_t.intl.load()}
                </Button>
            </Dialog.Panel>
        </Dialog>
    );
}
